import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Form,
  Input,
  Select,
  Modal,
  Typography,
  Button,
  DatePicker,
  Checkbox,
  notification,
  Radio,
  Alert,
} from "antd";
import SuppliersApi from "../../Apis/SuppliersApi";
import GoodInwardApi from "../../Apis/GoodInwardApi";
import ProductApi from "../../Apis/ProductApi";
import TextArea from "antd/es/input/TextArea";
// import RuntimeConfigsApi from "../../Apis/RuntimeConfigsApi";
import dayjs from "dayjs";
import moment from "moment";
import { AudioOutlined, InfoCircleFilled, LoadingOutlined, ReloadOutlined, SyncOutlined } from "@ant-design/icons";
import DepartmentModelGoodInward from "../../DropDowns/DepartmentModelGoodInward";
import ProductModelGoodInward from "../../DropDowns/ProductModelGoodInward";
const { Title } = Typography;

function AddGoodInward({ visible, onClose }) {
  const [formAdd] = Form.useForm();
  const [Suppliers, setSuppliers] = React.useState([]);
  const [loading, setLoading] = useState(false);
  const [TotalPageNew, setTotalPageNew] = useState(null);
  const [page, setPage] = useState(0);

  const [SetSupplier, Set_Supplier] = useState(null);
  const [SetDepartment, Set_Department] = useState(null);
  const [BtnDisable, Set_BtnDisable] = useState(false);
  const [VanCondotion, Set_VanCondotion] = useState(null);
  const [CorrectiveAction, Set_CorrectiveAction] = useState(null);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));


  const [Products, setProducts] = React.useState([]);
  const getProducts = useCallback(() => {
    ProductApi.Listproducts()
      .then((response) => {
        setProducts(response?.payloadDto);

      })
      .catch((err) => {
        console.log(err);
      });
  }, []);


  // const [RuntimeConfigs, setRuntimeConfigs] = React.useState([]);
  // const getRuntimeConfigsApi = useCallback(() => {
  //   RuntimeConfigsApi.ListRuntimeConfigs()
  //     .then((response) => {
  //       setRuntimeConfigs(response.payloadDto.filter(item => item?.tag === 'CURRENCY_TYPE_CONFIG'));
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }, []);

    const changeTemperature = (delta) => {
    const current = Number(formAdd.getFieldValue("temperature") || 0);
    const newValue = current + delta;

    formAdd.setFieldsValue({
      temperature: newValue,
    });

    handleInputChange({
      target: { value: String(newValue) },
    });
  };

  const fetchDepartments = async () => {
    try {
      setLoading(true);
      SuppliersApi.Listsuppliers(page, 10)
        .then((response) => {
          // setDepartments(response?.payloadDto);
          setTotalPageNew(response.totalPages);
          setSuppliers(prevDepartments => [...prevDepartments, ...response?.payloadDto]);

          setPage(prevPage => prevPage + 1);
          setLoading(false);

        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error('Error fetching departments:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // getRuntimeConfigsApi();
    fetchDepartments();
  }, []);

  const [selectedItems, setSelectedItems] = useState(null);
  const [selectedmax, setselectedmax] = useState(null);
  const [selectedmin, setselectedmin] = useState(null);
  const [selectNote, setselectNote] = useState(null);

  const handleChangeModify = (item) => {
    setSelectedItems(item);
    if (item === "Refrigerated") {
      setselectedmin(0)
      setselectedmax(5)
      setselectNote("Temperatures should be between 0℃ and 5℃")
    } else if (item === "Freezer") {
      setselectedmin(null)
      setselectedmax(-18)
      setselectNote("Temperatures should be below (-18)℃")
    } else if (item === "Ice cream freezer") {
      setselectedmin(-23)
      setselectedmax(-18)
      setselectNote("Temperatures should be between (-23)℃ and (-18)℃")
    } else if (item === "Ambient") {
      setselectedmin(null)
      setselectedmax(null)
      setselectNote(null)
    } else {
      setselectedmin(null)
      setselectNote(null)
      setselectedmax(null)
    }

    setReCheck(false)
    setReCheckvalid(false)
  };

  const handleSubmit = (data) => {
    Set_BtnDisable(true);

    // const SelectDate = moment(data.createDate).format("DD/MM/YYYY");
    const unixTimestamp = convertToUnixTimestamp(data.createDate);
    const productDetails = Products.find((item) => item.id === data.productId);
    let formData = JSON.stringify({
      goodInwardCreateDate: unixTimestamp,
      deliveryDocketNumber: data.deliveryDocketNumber,
      vanCondition: VanCondotion,
      temperature: data.temperature,
      unit: productDetails?.unitUomOne,
      quantity: data.quantity,
      total: data.total,
      correctiveAction: CorrectiveAction ? CorrectiveAction : '',
      remark: data.DeclineRemark ? data.DeclineRemark : '',
      temperatureRecheck: data.temperatureRecheck ? data.temperatureRecheck : "",
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
      supplierDTO: {
        id: data.supplierId,
      },
      institutionDTO: {
        id: data.institutionId,
      },
      productDTO: {
        id: data?.productId,
        unit: productDetails?.unitUomOne,
        institutionDTO: {
          id: productDetails?.institutionDTO?.id,
        },
      },
    });

    GoodInwardApi.CreateGoodInward(formData)
      .then((response) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Created</span>,
          description: "Created Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        setTimeout(() => {
          window.location.reload();
        }, 500);
      })
      .catch((err) => {
        console.log(err);
        Set_BtnDisable(false);
        // Error Notification
        if (err.apiError.status) {
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
            ),
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  function convertToUnixTimestamp(dateValue) {
  if (!dateValue) return null;

  if (typeof dateValue === "string") {
    const parts = dateValue.split("/");
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;
    const year = parseInt(parts[2], 10);

    return Date.UTC(year, month, day);
  }

  return dateValue.startOf("day").valueOf();
}
  const currentDate = moment().format("DD/MM/YYYY");
  const [isTemperatureClicked, setIsTemperatureClicked] = useState(false);
  const [IsReloadproductClicked, setIsReloadproductClicked] = useState(false);
  const [IsReloadSupplierClicked, setIsReloadSupplierClicked] = useState(false);
  const [IsReloadDepartmentClicked, setIsReloadDepartmentClicked] =
    useState(false);

  const handleTemperatureClick = () => {
    setIsTemperatureClicked(!isTemperatureClicked);
  };

  const handleReloadSupplierClick = () => {
    fetchDepartments();
    setIsReloadSupplierClicked(true);
    setTimeout(() => {
      setIsReloadSupplierClicked(false);
    }, 1000);
  };


  const handleCancel = () => {
    formAdd.resetFields();
    onClose();
  };
  const handleChangeSupplier = (value) => {
    SuppliersApi.SingleSuppliers(value)
      .then((response) => {
        console.log(response?.payload)
        Set_Supplier(response?.payload?.id)
        Set_Department(response?.payload)
        formAdd.setFieldsValue({
          institutionId: response?.payload?.institutionDTO?.id,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const currentDateNew = moment().startOf('day');

  const disabledDate = current => {
    return current && current < currentDateNew;
  };


  const [isRecording, setIsRecording] = useState(false);
  const [isRecording2, setIsRecording2] = useState(false);
  const [isRecordingproductCode, setIsRecordingproductCode] = useState(false);
  const startRecording = (fieldN) => {

    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = 'en-US';
    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      let fieldName = fieldN;
      
        if (selectedItems === "Freezer") {
          if (transcript > -18) {
            setReCheck(true)
            setReCheckvalid("Temperature must be below -18℃")
          } else {
            setReCheck(false)
            setReCheckvalid(false)
          }
        }
    else if (selectedmin !== null && selectedmax !== null) {
      if (transcript < parseInt(selectedmin) || transcript > parseInt(selectedmax)) {
        setReCheck(true)
        selectedmin !== -18
          ? setReCheckvalid(`Temperature must be between ${selectedmin} and ${selectedmax}`)
          : setReCheckvalid(`Temperature must be between ${selectedmax} and ${selectedmin}`)
      } else {
        setReCheck(false)
        setReCheckvalid(false)
      }
    }
      formAdd.setFieldsValue({
        [fieldName]: transcript,
      });
    };

    recognition.start();
    if (fieldN === 'deliveryDocketNumber') {
      setIsRecordingproductCode(true);
    } else if (fieldN === 'temperature') {
      setIsRecording(true);
    } else if (fieldN === 'temperatureRecheck') {
      setIsRecording2(true);
    }
  };

  const stopRecording = () => {
    setIsRecording(false);
    setIsRecording2(false);
    setIsRecordingproductCode(false);
  };

  const [ReCheck, setReCheck] = useState(false);
  const [ReCheckvalid, setReCheckvalid] = useState(false);
  const handleInputChange = (event) => {
    const newItem = event.target.value.trim();

     if (selectedItems === "Freezer") {
      if (newItem > -18) {
        setReCheck(true)
        setReCheckvalid("Temperature must be below -18℃")
      } else {
        setReCheck(false)
        setReCheckvalid(false)
      }
    } 
  else if (selectedmin !== null && selectedmax !== null) {
    if (newItem < parseInt(selectedmin) || newItem > parseInt(selectedmax)) {
      setReCheck(true)
      selectedmin !== -18
        ? setReCheckvalid(`Temperature must be between ${selectedmin} and ${selectedmax}`)
        : setReCheckvalid(`Temperature must be between ${selectedmax} and ${selectedmin}`)
    } else {
      setReCheck(false)
      setReCheckvalid(false)
    }
  }

  };

  const handleScroll = (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    const nearBottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 1; // Add a small buffer
    if (bottom || nearBottom) {
      if (TotalPageNew > page) {
        fetchDepartments();
      }
    }
  };

  return (
    <>
      <Modal
        footer={[]}
        width={700}
        visible={visible}
        maskClosable={false}
        onCancel={handleCancel}
        onOk={onClose}
      >
        <Title level={4} className="text-center Primary-Font mb-4 pb-3">
          Goods Inward Form
        </Title>
        <Form
          form={formAdd}
          name="nest-messages"
          layout="horizontal"
          labelCol={{
            span: 9,
          }}
          wrapperCol={{
            span: 16,
          }}
          className="FormClass IndividualProduct-Model"
          onFinish={handleSubmit}
        >
          <>
            <div className="Product-createDate">
              <div className="mb-3" style={{ display: 'flex', fontSize: '18px', alignItems: 'center' }}>
                <b className="mx-2">{currentDate}</b>
                <img
                  src="/assest/Images/cal.png"
                  style={{ width: '32px' }}
                  className="logo-png"
                />
              </div>
              <Form.Item
                name="createDate"
                initialValue={dayjs(currentDate, "DD/MM/YYYY")}
                className="text-lable col-lg-6 col-sm-12 col-md-7 d-none"
                rules={[
                  {
                    required: true,
                    message: "Please enter Date.",
                  },
                ]}
              >
                <DatePicker
                  disabledDate={disabledDate}
                  format={"DD/MM/YYYY"}
                  className="form-control control-input"
                />
              </Form.Item>
            </div>
            <Form.Item
              name="deliveryDocketNumber"
              label="Delivery Docket Number"
              className="text-lable"
              rules={[
                {
                  required: true,
                  message: "Please enter Delivery Docket Number",
                },
              ]}
            >
              <Input
                type="text"
                placeholder="Delivery Docket Number"
                className="control-input speachBtn  mb-0"
                style={{
                  border: 'none',
                  padding: '0px',
                  margin: '0px',
                  marginBottom: '7px',
                }}
                addonAfter={
                  <>
                    <Button
                      onMouseDown={() => startRecording('deliveryDocketNumber')}
                      onMouseUp={stopRecording}
                      onMouseLeave={stopRecording}
                      style={{
                        border: 'none',
                        padding: 0,
                        margin: 0,
                        background: 'none',
                        cursor: 'pointer',
                      }}
                    >
                      {isRecordingproductCode ? <LoadingOutlined /> : <AudioOutlined />}
                    </Button>
                  </>
                }
              />
            </Form.Item>

            <div className="row product-row d-flex align-items-center">
              <Form.Item
                name="supplierId"
                label="Name of the Supplier :"
                className="text-lable pt-3 col-10"
                rules={[
                  {
                    required: true,
                    message: "Please Select Supplier.",
                  },
                ]}
              >
                <Select
                  className="control-Select mb-1"
                  onChange={(value) =>
                    handleChangeSupplier(value)
                  }
                  placeholder="Select Supplier Name"
                  onPopupScroll={handleScroll}
                >
                  {Suppliers.map((option, index) => (
                    <Select.Option key={option.id} value={option.id}>
                      {option?.supplierName} ({option?.institutionDTO?.institutionName})
                    </Select.Option>
                  ))}
                  {loading && (
                    <Select.Option disabled key="loading" value="loading">
                      Loading...
                    </Select.Option>
                  )}
                </Select>
              </Form.Item>
              <div className=" col-1 d-flex justify-content-center">
                {IsReloadSupplierClicked ? (
                  <div className="refresh-btn">
                    <SyncOutlined spin className="px-2" />
                  </div>
                ) : (
                  <div
                    className="refresh-btn"
                    onClick={handleReloadSupplierClick}
                    style={{ cursor: "pointer" }}
                  >
                    <ReloadOutlined className="px-2" />
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-4"></div>
              <div className="col-6" style={{ paddingLeft: "30px" }}>
                <Link to={"/masters/suppliers/add-Supplier"} target="_blank">
                  <u>Create New Supplier</u>
                </Link>
              </div>
            </div>

            <DepartmentModelGoodInward SetDepartment={SetDepartment} />

            <ProductModelGoodInward SetDepartment={SetDepartment} />

            <Form.Item
              name="VanCondition"
              label="Van Condition"
              className="text-lable pt-2"
              rules={[
                {
                  required: VanCondotion === null ? true : false,
                  message: "Please enter Van Condition",
                },
              ]}
            >
              <div className="GoodsInward-Checkbox">
                <Checkbox
                  checked={VanCondotion === "Accept"}
                  onChange={() => Set_VanCondotion("Accept")}
                >
                  Accept
                </Checkbox>
                <Checkbox
                  checked={VanCondotion === "Decline"}
                  onChange={() => Set_VanCondotion("Decline")}
                >
                  Not Accept
                </Checkbox>
              </div>
            </Form.Item>
            {VanCondotion === "Decline" && (
              <Form.Item
                name="DeclineRemark"
                label="Remark"
                className="text-lable pt-3"
              >
                <TextArea
                  className="form-control control-input p-3"
                  rows={3}
                  style={{ resize: "none" }}
                ></TextArea>
              </Form.Item>
            )}
            <Form.Item
              name="options"
              label=" "
              className="text-lable classGoodTemp pt-3"
            >
              <div style={{ display: 'flex', padding: '5px' }}>
                <Radio
                  style={{ paddingRight: '65px' }}
                  checked={selectedItems === "Refrigerated"}
                  onChange={() => handleChangeModify("Refrigerated")}
                >
                  Refrigerated
                </Radio>

                <Radio
                  checked={selectedItems === "Ambient"}
                  onChange={() => handleChangeModify("Ambient")}
                >
                  Ambient
                </Radio>
              </div>

              <div style={{ display: 'flex', padding: '5px' }}>

                <Radio
                  style={{ paddingRight: '30px' }}
                  checked={selectedItems === "Ice cream freezer"}
                  onChange={() => handleChangeModify("Ice cream freezer")}
                >
                  Ice cream freezer
                </Radio>
                <Radio
                  checked={selectedItems === "Freezer"}
                  onChange={() => handleChangeModify("Freezer")}
                >
                  Freezer
                </Radio>
              </div>

            </Form.Item>
            {/* <p style={{ textAlign: 'end', fontSize: '13px', color: 'blue',fontWeight:'500' }}><InfoCircleFilled style={{ fontSize: '9px' }} className="inforIcon" />  Before entering a temperature please choose one of the options above</p> */}
            <Alert message="Select a storage condition to continue" type="info" style={{color: "blue", fontWeight: "bold", textAlign: "center", marginBottom: "10px"}}/>
            <Form.Item
              name="temperature"
              label="Temperature"
              className={selectedItems ? 'text-lable pt-0' : 'd-none'}
              rules={[
                {
                  required: true,
                  message: "Please enter Temperature",
                }
              ]}
            >
              <Input
                type="number"
                name="temperature"
                onChange={handleInputChange}
                addonBefore={
                  <Button
                    icon={<MinusOutlined />}
                    onClick={() => changeTemperature(-1)}
                  />
                }
                addonAfter={
                  <>
                    <Button
                      icon={<PlusOutlined />}
                      onClick={() => changeTemperature(1)}
                    />
                    <Button
                      onMouseDown={() => startRecording("temperature")}
                      onMouseUp={stopRecording}
                      onMouseLeave={stopRecording}
                    >
                      {isRecording ? <LoadingOutlined /> : <AudioOutlined />}
                    </Button>
                  </>
                }
              />
            </Form.Item>
            {/* <p style={{ textAlign: 'center', fontSize: '13px', color: 'blue' }} className={selectNote ? 'mb-2' : 'd-none'}><InfoCircleFilled style={{ fontSize: '9px' }} className="inforIcon" /> {selectNote}</p> */}
            <Alert message={selectNote} type="error" className={selectNote ? 'temp-error-text' : 'd-none'} />
            {ReCheck && (
              <Form.Item
                className={ReCheck ? 'text-lable pt-0' : 'd-none'}
                name="temperatureRecheck"
                label={<>&nbsp;</>}
              >
                <p style={{ color: 'red' }} className={ReCheckvalid ? 'mb-2' : 'd-none'}>{ReCheckvalid}</p>

                <p
                  className="m-0"
                  style={{ cursor: "pointer" }}
                  onClick={handleTemperatureClick}
                >
                  Re-Check
                </p>
              </Form.Item>
            )}

            {isTemperatureClicked && (
              <Form.Item
                name="temperatureRecheck"
                label="Temperature Re-Check"
                className="text-lable pt-2"
              >
                <Input
                  type="number"
                  placeholder="0"
                  className="control-input col-6"
                  style={{
                    border: 'none',
                    textAlign: 'end',
                    padding: '0px'
                  }}
                  addonAfter={
                    <>
                      <Button
                        className="StockTempClass"
                        style={{
                          border: 'none',
                          padding: 0,
                          paddingTop: '0px',
                          margin: 0,
                          background: 'none',
                          cursor: 'pointer',
                        }}
                      >
                        'C
                      </Button>
                      <Button
                        onMouseDown={() => startRecording('temperatureRecheck')}
                        onMouseUp={stopRecording}
                        onMouseLeave={stopRecording}
                        style={{
                          border: 'none',
                          padding: 0,
                          margin: 0,
                          marginLeft: '10px',
                          paddingLeft: '5px',
                          paddingBottom: '5px',
                          background: 'none',
                          borderRadius: '0px',
                          borderLeft: '1px solid #d9d9d9',
                          cursor: 'pointer',
                        }}
                      >
                        {isRecording2 ? <LoadingOutlined /> : <AudioOutlined />}
                      </Button>
                    </>
                  }
                />
              </Form.Item>
            )}


            {/* <div className="d-flex justify-content-center pt-4">
              <Button
                type="primary"
                disabled={BtnDisable}
                htmlType="submit"
                className="btn btn-primary btn-save mx-2"
                style={{ width: "37%" }}
              >
                Create
              </Button>
              <Link
                type="primary"
                to={""}
                className="btn btn-primary btn-back mx-2 w-20"
                style={{ width: "37%" }}
                onClick={handleCancel}
              >
                Cancel
              </Link>
            </div> */}

            <div
              className="d-flex justify-content-between pt-4"
              style={{
                gap: "10px",
                padding: "16px 24px 0", // same horizontal padding as modal content
              }}
            >
              <Button
                type="primary"
                htmlType="submit"
                disabled={BtnDisable}
                style={{
                  flex: 1,
                  height: 40,
                  borderRadius: 6,
                }}
              >
                Create
              </Button>

              <Button
                onClick={handleCancel}
                style={{
                  flex: 1,
                  height: 40,
                  borderRadius: 6,
                }}
              >
                Cancel
              </Button>
            </div>
          </>
        </Form>
      </Modal >
    </>
  );
}

export default AddGoodInward;
